import { BoxProps } from '@mui/material';
import { StatusBadge } from '../pure/status-badge/status-badge.component';

export interface WorkflowDeliveryStatusProps extends BoxProps {
  label: string;
  color: string;
  fontColor?: string;
  align?: 'left' | 'center' | 'right';
  fontSize?: string;
  showTooltip?: boolean;
  /** Hug the label instead of the fixed table-cell width, for tight contexts (e.g. search result rows). */
  condensed?: boolean;
}

export const WorkflowStatusBadge = ({
  label,
  color,
  fontColor,
  className,
  align,
  fontSize = '13px',
  showTooltip = true,
  condensed,
  ...rest
}: WorkflowDeliveryStatusProps) => {
  const condensedProps = condensed ? ({ collapse: 'wrap-sides', desktopHeight: '24px' } as const) : undefined;
  return (
    <StatusBadge
      label={label}
      color={color}
      fontColor={fontColor}
      cornerRounding="med"
      fontSize={fontSize}
      showTooltip={showTooltip}
      align={align}
      {...condensedProps}
      {...rest}
    />
  );
};
